var _g, _g2, _title;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHaskell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "file_type_haskell")), /*#__PURE__*/React.createElement("polygon", {
    points: "2 25.882 8.588 16 2 6.118 6.941 6.118 13.529 16 6.941 25.882 2 25.882",
    style: {
      fill: "#453a62"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "8.588 25.882 15.177 16 8.588 6.118 13.529 6.118 26.706 25.882 21.765 25.882 17.647 19.706 13.529 25.882 8.588 25.882",
    style: {
      fill: "#5e5086"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.51 20.118 22.314 16.824 30 16.823 30 20.118 24.51 20.118",
    style: {
      fill: "#8f4e8b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.216 15.177 19.02 11.883 30 11.882 30 15.177 21.216 15.177",
    style: {
      fill: "#8f4e8b"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaskell);
export default __webpack_public_path__ + "static/media/haskell.fe4927371978ea624e1cd2cb8cdd8353.svg";
export { ForwardRef as ReactComponent };